import englishTestNames from '../../../assets/translations/english-test-names.json'

export const englishTestNamesContent: any = englishTestNames
